// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__biv1H","mdfcContainer":"Card_mdfcContainer__H8FFD","card":"Card_card__uFbbj","flipCard":"Card_flipCard__QHjb6"};